export default __webpack_public_path__ + "img/operation-maintenance.0a810eba.png";